package com.essntl.features.task.ui.alltasks.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.alltasks.AllTasksEvent
import com.essntl.features.task.ui.alltasks.AllTasksNavigation
import com.essntl.features.task.ui.alltasks.AllTasksState
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun OverdueTasksDialog(
    state: AllTasksState,
    onEvent: (AllTasksEvent) -> Unit,
    onNavigation: (AllTasksNavigation) -> Unit,
    selectedTask: TaskModel,
    isLoading: Boolean,
    onDismissRequest: () -> Unit,
) {
    BasicAlertDialog(
        onDismissRequest = onDismissRequest,
        modifier = Modifier.fillMaxSize(0.7f),
        properties = DialogProperties(
            usePlatformDefaultWidth = false,
        ),
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(25.dp)),
        ) {
            Column(
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .background(color = MaterialTheme.esColorScheme.bgPrimary)
                    .padding(bottom = 1.spacing),
            ) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color.White)
                        .padding(
                            vertical = 3.spacing,
                            horizontal = 2.5.spacing,
                        ),
                ) {
                    Text(
                        text = "Overdue Tasks",
                        style = MaterialTheme.esTypography.h3Bold24,
                        color = MaterialTheme.esColorScheme.textPrimary,
                        modifier = Modifier.align(Alignment.CenterStart),
                    )

                    EsSmallOutlineIconButton(
                        onClick = onDismissRequest,
                        iconRes = EsIcons.Close,
                        modifier = Modifier.align(Alignment.CenterEnd),
                    )
                }

                TaskListColumn(
                    state = state,
                    onEvent = onEvent,
                    onNavigation = onNavigation,
                    selectedTask = selectedTask,
                    isLoading = isLoading,
                    overdue = true,
                )
            }
        }
    }
}